import { render } from "./chamamento-aberto.vue?vue&type=template&id=2ebf7b96&scoped=true"
import script from "./chamamento-aberto.vue?vue&type=script&lang=js"
export * from "./chamamento-aberto.vue?vue&type=script&lang=js"

import "./chamamento-aberto.vue?vue&type=style&index=0&id=2ebf7b96&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebf7b96"]])

export default __exports__